import React, { Component } from 'react'

import _ from 'lodash'
import NKModal from '../felles/Dialogs/NKModal.jsx'
import JaNeiDialog from '../felles/Dialogs/JaNeiDialog.jsx'

import ReactTable from '@norkart/react-table'
import NkaButton from 'nka-button'

import ArbeidslisteModal from './arbeidsliste/arbeidslistemodal.jsx'
import ContextMenu from '../felles/ContextMenu'
import { datoFormatDagMnd } from '../felles/utils/dato-format-tabell'
import KartModal from '../felles/Kart/kartContainer.jsx'
import { Arbeidslistestatus } from '../felles/utils/statuskoder'

import '@norkart/react-table/dist/react-table.css'
import 'nka-button/dist/style.css'

export default class Planlegging extends Component {
    constructor() {
        super()

        this.state = {
            isNyArbeidslisteModalOpen: false,
            endreArbeidsliste: false,
            tittel: '',
            beskrivelse: '',
            planlagtdato: null,
            id: '',
            isKartModalOpen: false,
            isFjernArbeidslisteModalOpen: false,
            valgtArbeidsliste: null
        }

        this._getColumns = this._getColumns.bind(this)
        this._openNyArbeidslisteModal = this._openNyArbeidslisteModal.bind(this)
        this._closeNyArbeidslisteModal = this._closeNyArbeidslisteModal.bind(this)
        this._nyArbeidsListe = this._nyArbeidsListe.bind(this)
        this._onClickAktiver = this._onClickAktiver.bind(this)
        this._onClickFjern = this._onClickFjern.bind(this)
        this._onClickDeaktiver = this._onClickDeaktiver.bind(this)
        this._endreArbeidslisteModal = this._endreArbeidslisteModal.bind(this)
        this._visikart = this._visikart.bind(this)
        this._closeVisiKart = this._closeVisiKart.bind(this)
        this._lukkFjernArbeidslisteDialog = this._lukkFjernArbeidslisteDialog.bind(this)
        this._fjernArbeidsliste = this._fjernArbeidsliste.bind(this)
    }

    _onClickAktiver(item) {        
        this.props.settStatusArbeidsListe(item, Arbeidslistestatus.Aktivert)
    }

    _onClickFjern(item) {
        this.setState({
            isFjernArbeidslisteModalOpen: true,
            valgtArbeidsliste: item
        })
    }

    _fjernArbeidsliste() {
        this.props.fjernArbeidsliste(this.state.valgtArbeidsliste)
        this.setState({
            isFjernArbeidslisteModalOpen: false,
            valgtArbeidsliste: null
        })
    }

    _lukkFjernArbeidslisteDialog() {
        this.setState({
            isFjernArbeidslisteModalOpen: false
        })
    }

    _onClickDeaktiver(item) {
        this.props.settStatusArbeidsListe(item, Arbeidslistestatus.Deaktiv)
    }

    _endreArbeidslisteModal(item) {
        this.setState({
            tittel: item.Tittel,
            beskrivelse: item.Beskrivelse,
            planlagtdato: item.Startdato,
            starttidspunkt: item.StartTidspunkt,
            sluttidspunkt: item.SluttTidspunkt,
            tilknytteteBrukere: item.Brukere,
            id: item.Id,
            isNyArbeidslisteModalOpen: true,
            endreArbeidsliste: true
        })
    }

    _openNyArbeidslisteModal() {
        this.setState({
            tittel: '',
            beskrivelse: '',
            planlagtdato: '',
            id: 0,
            isNyArbeidslisteModalOpen: true,
            endreArbeidsliste: false
        })
    }

    _closeNyArbeidslisteModal() {
        this.setState({ isNyArbeidslisteModalOpen: false })
    }

    _onRowclicked(row) {
        this.props.hist.push('/planlegging/' + row.Id)
    }

    _visikart(row) {
        this.setState({
            id: row.Id,
            isKartModalOpen: true
        })
    }

    _closeVisiKart() {
        this.setState({ isKartModalOpen: false })
    }

    _nyArbeidsListe(arbeidsliste, endre) {
        if (endre) {
            this.props.endreArbeidsliste(arbeidsliste)
        } else {
            this.props.leggTilNyArbeidsliste(arbeidsliste)
        }
        this.setState({ isNyArbeidslisteModalOpen: false })
    }

    _getColumns() {
        return [
            {
                id: 'Tittel',
                name: 'Navn',
                isSorted: false,
                sortable: false,
                formatter: function(item) {
                    return _.truncate(item.Tittel, { length: 20 })
                }
            },
            {
                id: 'Beskrivelse',
                name: 'Beskrivelse',
                sortable: false,
                isSorted: false,
                formatter: function(item) {
                    return _.truncate(item.Beskrivelse, { length: 50 })
                }
            },
            {
                id: 'Status',
                name: 'Aktivert',
                sortParams: 'Status',
                isSorted: false,
                sortable: true,
                filterable: false,
                formatter: function(item) {
                    if (item.Status === Arbeidslistestatus.Aktivert) return 'Ja'
                    else return 'Nei'
                }
            },
            {
                id: 'Startdato',
                name: 'Planlagt dato',
                isSorted: false,
                sortParams: 'Startdato',
                sortable: true,
                formatter: function(item) {
                    if (item.Sluttdato)
                        return (
                            datoFormatDagMnd(item.Startdato) +
                            ' - ' +
                            datoFormatDagMnd(item.Sluttdato)
                        )
                    else return datoFormatDagMnd(item.Startdato)
                }
            },
            {
                id: 'Brukere',
                name: 'Ansvarlige',
                isSorted: false,
                sortable: true,
                formatter: function(item) {
                    let mapt = _.map(item.Brukere, _.property('Navn'))
                    return _.join(mapt, ', ')
                }
            },
            {
                id: 'AntallVannmaalere',
                name: 'Antall',
                isSorted: false,
                sortable: true,
                sortParams: 'AntallVannmaalere'
            },
            {
                id: 'Meny',
                isSorted: false,
                sortable: false,
                formatter: function(item) {
                    if (item.Status === Arbeidslistestatus.Aktivert) {
                        return (
                            <ContextMenu.Button
                                title="Meny"
                                icon="meny"
                                iconColor="nk-black"
                                className="inlinebtn"
                            >
                                <ContextMenu.Item eventKey={item} onSelect={this._onClickFjern}>
                                    Slett...
                                </ContextMenu.Item>
                                <ContextMenu.Item eventKey={item} onSelect={this._visikart}>
                                    Vis i kart
                                </ContextMenu.Item>
                            </ContextMenu.Button>
                        )
                    } else {
                        return (
                            <ContextMenu.Button
                                title="Meny"
                                icon="meny"
                                iconColor="nk-black"
                                className="inlinebtn"
                            >
                                <ContextMenu.Item
                                    eventKey={item}
                                    onSelect={this._endreArbeidslisteModal}
                                >
                                    Endre...
                                </ContextMenu.Item>
                                <ContextMenu.Item eventKey={item} onSelect={this._onClickFjern}>
                                    Slett...
                                </ContextMenu.Item>
                                <ContextMenu.Item eventKey={item} onSelect={this._visikart}>
                                    Vis i kart
                                </ContextMenu.Item>
                            </ContextMenu.Button>
                        )
                    }
                }.bind(this)
            }
        ]
    }

    render() {
        let kolonner = this._getColumns()

        return (
            <div className="listeContainer">
                <h2>Planlegging</h2>

                   <NkaButton icon="pluss" color="nk-white" onClick={this._openNyArbeidslisteModal}>
                        Ny arbeidsliste
                    </NkaButton>

                <p />
                <ReactTable
                    items={this.props.arbeidslister}
                    idProperty="Id"
                    showIndex={false}
                    filterable={false}
                    itemsPrPage={null}
                    columns={kolonner}
                    onRowClick={this._onRowclicked.bind(this)}
                />

                {this.state.isNyArbeidslisteModalOpen && (
                    <ArbeidslisteModal
                        onClose={this._closeNyArbeidslisteModal}
                        isOpen={this.state.isNyArbeidslisteModalOpen}
                        tittel={this.state.tittel}
                        beskrivelse={this.state.beskrivelse}
                        planlagtdato={this.state.planlagtdato}
                        onLagtTilArbeidsliste={this._nyArbeidsListe}
                        endreArbeidsliste={this.state.endreArbeidsliste}
                        starttidspunkt={this.state.starttidspunkt}
                        sluttidspunkt={this.state.sluttidspunkt}
                        id={this.state.id}
                        tilknytteteBrukere={this.state.tilknytteteBrukere}
                    />
                )}

                <NKModal size="large" isOpen={this.state.isKartModalOpen}>
                    <KartModal id={this.state.id} onClose={this._closeVisiKart} />
                </NKModal>

                <JaNeiDialog
                    melding="Fjerne arbeidsliste. Vil du fortsette?"
                    isOpen={this.state.isFjernArbeidslisteModalOpen}
                    tittel="Fjern arbeidsliste"
                    onAvbryt={this._lukkFjernArbeidslisteDialog}
                    onOk={this._fjernArbeidsliste}
                />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/planlegging/planlegging.jsx